<sub-header [isModal]="true" [includeContextHelp]="true" [windowHash]=windowHash></sub-header>
<p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1">
    <div class="container-fluid">
        <div class="row" *ngIf="this.user">
            <div class="col-sm-2">
                <div class="text-center">
                    <div>
                        <span class="fa-stack fa-2x">
                            <i class="fa fa-circle fa-stack-2x" [style.color]="this.userColor" aria-hidden="true"></i>
                            <strong class="fa-inverse fa-stack-1x calendar-text">{{this.userLetters}}</strong>
                        </span>
                        <div class="m-t-xs font-bold">
                            <h2>{{this.user.person.position}}</h2>
                        </div>
                    </div>
                    <!--img alt="image" class="img-circle m-t-xs img-responsive" src="img/a2.jpg"-->
                </div>
            </div>
            <div class="col-sm-4 info-detail-user">
                <h3>
                    <strong>{{this.userFullName}}</strong>
                </h3>
                <p>
                    <i class="fa fa-user" aria-hidden="true"></i>
                    <strong> {{ 'General.user' | translate }} </strong>
                   <br>{{this.user.identifier}}
                </p>
                <!--p><i class="fa fa-map-marker" aria-hidden="true" ></i> Riviera State 32/106</p-->
                <p>
                    <i class="fa fa-users" aria-hidden="true"></i>
                    <strong> {{ 'UserDetail.organizational.unit' | translate }} </strong>
                    <br>{{this.organizationalUnit?.name}} <span class="badge badge-light border border-secondary ml-2 pt-0 pb-0"><small>{{this.organizationalUnit?.identifier}}</small></span><span class="badge badge-light border border-secondary ml-2 pt-0 pb-0"><small>{{this.organizationalUnit?.unitId}}</small></span>
                </p>
                <p>
                    <i class="fa fa-envelope-open-o" aria-hidden="true"></i>
                    <strong> {{ 'UserDetail.email' | translate }}</strong>
                    <br> {{this.user.person.email}}
                </p>
                <!-- <p><i class="fa fa-id-card-o" aria-hidden="true"></i><strong> {{ 'UserDetail.identification.document' | translate }}</strong><br>                                    {{this.user.person.identifier}}</p> -->
                <!--address>
                                <strong>Twitter, Inc.</strong><br> 795 Folsom Ave, Suite 600<br> San Francisco, CA 94107
                                <br>
                                <abbr title="Phone">P:</abbr> (123) 456-7890
                            </address-->
            </div>
            <div class="col-sm-6">
                <h3>
                    <strong>{{ 'UserDetail.profiles' | translate }}</strong>
                </h3>
                <ul class="todo-list m-t small-list">
                    <li *ngFor='let profile of this.user.listProfiles;  let i = index'>
                        <span class="m-l-xs">{{profile.description}} <span class="badge badge-light border border-secondary float-right pt-0 pb-0"><small>{{profile.application}}-{{profile.identifier}}</small></span></span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</p-scrollPanel>